import angular from 'angular';
import { UlyticsModule, ULYTICS_ACTIONS } from '@updater/ulytics';
import { ENVIRONMENT } from '../../environment';
import { selectors } from '../../state';

const { keys } = ENVIRONMENT;

// https://stackoverflow.com/a/17447718/89594
export const isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
export const isEdge15 = /Edge\/15.*/.test(navigator.userAgent);

export const AnalyticsModule = angular
  .module('app.analytics', [UlyticsModule.name])
  .constant('ULYTICS_CONFIG', {
    segmentWriteKey: keys && keys.segment,
    segmentLoadOptions: {
      integrations: {
        // TODO: FullStory + WebComppnents Polyfill + IE11 = unresponsive.
        // Disable FullStory for IE11 only. [ch16374] [ch22988]
        FullStory: !isIE11,
      },
    },
    storeServiceName: 'updStore',
    getStaticPropertiesSelector: selectors.analytics.staticProperties,
    ignoreActions: [ULYTICS_ACTIONS.PAGE, ULYTICS_ACTIONS.TRACK],
  });
